/* BORN — Displays · v2 interaction layer. No dependencies. Fails open. */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---------------- Reveal (IntersectionObserver + scroll sweep, fail-open) ---------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('[data-bn-reveal]:not([data-bn-bound])');
    if (!nodes.length) return;
    each(nodes, function (n) { n.setAttribute('data-bn-bound', '1'); });

    if (reduced || !('IntersectionObserver' in window)) { each(nodes, function (n) { n.classList.add('is-in'); }); return; }

    // stagger siblings
    var groups = new Map();
    each(nodes, function (n) {
      var p = n.parentElement, i = groups.get(p) || 0;
      if (!n.style.getPropertyValue('--bn-delay')) n.style.setProperty('--bn-delay', Math.min(i, 7) * 70 + 'ms');
      groups.set(p, i + 1);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    each(nodes, function (n) { io.observe(n); });
  }

  // Secondary sweep: releases anything that has reached the viewport, in case the observer is slow.
  function sweepReveal() {
    var pending = document.querySelectorAll('[data-bn-reveal]:not(.is-in)');
    if (!pending.length) return;
    var limit = window.innerHeight * 0.96;
    each(pending, function (n) { if (n.getBoundingClientRect().top < limit) n.classList.add('is-in'); });
  }
  var sweeping = false;
  function onScrollSweep() { if (sweeping) return; sweeping = true; requestAnimationFrame(function () { sweeping = false; sweepReveal(); }); }

  /* ---------------- Pill nav: mega panels open upward; keyboard + touch ---------------- */
  function initPill() {
    var items = document.querySelectorAll('.bn-pill__item--has-mega');
    if (!items.length) return;
    var timer;
    function closeAll(except) {
      each(items, function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var t = it.querySelector(':scope > a, :scope > button'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    each(items, function (it) {
      var trig = it.querySelector(':scope > a, :scope > button'); if (!trig || it.dataset.bnBound) return;
      it.dataset.bnBound = '1';
      trig.setAttribute('aria-haspopup', 'true'); trig.setAttribute('aria-expanded', 'false');
      function clampToViewport() {
        // Centre the panel on its item, then pin to a viewport edge if it would overflow.
        var mega = it.querySelector('.bn-mega'); if (!mega) return;
        mega.style.left = ''; mega.style.right = ''; mega.style.translate = '';
        var r = mega.getBoundingClientRect(), vw = window.innerWidth, pad = 12;
        if (r.left < pad) { mega.style.left = '0'; mega.style.right = 'auto'; mega.style.translate = '0 0'; }
        else if (r.right > vw - pad) { mega.style.left = 'auto'; mega.style.right = '0'; mega.style.translate = '0 0'; }
      }
      function open() { clearTimeout(timer); closeAll(it); it.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); clampToViewport(); }
      function scheduleClose() { timer = setTimeout(function () { it.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); }, 160); }
      it.addEventListener('mouseenter', open);
      it.addEventListener('mouseleave', scheduleClose);
      it.addEventListener('focusin', open);
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); } });
      trig.addEventListener('click', function (e) {
        var touch = window.matchMedia('(hover: none)').matches;
        if (touch && !it.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.bn-pill__item--has-mega')) closeAll(null); });
  }

  /* ---------------- Mobile drawer ---------------- */
  function initDrawer() {
    var btn = document.querySelector('[data-bn-drawer-toggle]');
    var drawer = document.querySelector('.bn-drawer');
    if (!btn || !drawer || btn.dataset.bnBound) return;
    btn.dataset.bnBound = '1';
    function setOpen(o) { body.classList.toggle('bn-drawer-open', o); btn.setAttribute('aria-expanded', String(o)); drawer.setAttribute('aria-hidden', String(!o)); }
    btn.addEventListener('click', function () { setOpen(!body.classList.contains('bn-drawer-open')); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('bn-drawer-open')) { setOpen(false); btn.focus(); } });
    setOpen(false);
  }

  /* ---------------- Word-scroll cards: duplicate list for a seamless loop ---------------- */
  function initWords() {
    each(document.querySelectorAll('.bn-words__track:not([data-bn-cloned])'), function (track) {
      track.setAttribute('data-bn-cloned', '1');
      var kids = Array.prototype.slice.call(track.children);
      kids.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
    });
  }

  /* ---------------- Rails: arrows + active-card title sync ---------------- */
  function initRails() {
    each(document.querySelectorAll('[data-bn-rail]:not([data-bn-bound])'), function (wrap) {
      wrap.setAttribute('data-bn-bound', '1');
      var track = wrap.querySelector('.bn-rail'); if (!track) return;
      var prev = wrap.querySelector('[data-bn-rail-prev]');
      var next = wrap.querySelector('[data-bn-rail-next]');
      var titleA = wrap.querySelector('[data-bn-rail-title-a]');
      var titleB = wrap.querySelector('[data-bn-rail-title-b]');
      var cards = track.querySelectorAll('.bn-rail__card');

      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 20 : track.clientWidth * 0.8; }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        // active card = first whose left edge is at/after the track's left padding
        if (titleA && cards.length) {
          var tl = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
          var best = null, bestD = Infinity;
          each(cards, function (c) { var d = Math.abs(c.getBoundingClientRect().left - tl); if (d < bestD) { bestD = d; best = c; } });
          if (best) {
            if (best.dataset.title && titleA.textContent !== best.dataset.title) titleA.textContent = best.dataset.title;
            if (titleB && best.dataset.sub !== undefined) titleB.textContent = best.dataset.sub ? ' — ' + best.dataset.sub : '';
          }
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------------- Timeline: activate the step nearest the viewport centre ---------------- */
  function initTimeline() {
    each(document.querySelectorAll('.bn-timeline:not([data-bn-bound])'), function (tl) {
      tl.setAttribute('data-bn-bound', '1');
      var steps = tl.querySelectorAll('.bn-tl-step'); if (!steps.length) return;
      if (!steps[0].classList.contains('is-active')) steps[0].classList.add('is-active');
      function pick() {
        var mid = window.innerHeight * 0.5, best = null, bestD = Infinity;
        each(steps, function (s) { var r = s.getBoundingClientRect(); var c = r.top + r.height / 2; var d = Math.abs(c - mid); if (d < bestD) { bestD = d; best = s; } });
        if (best) each(steps, function (s) { s.classList.toggle('is-active', s === best); });
      }
      var t = false;
      window.addEventListener('scroll', function () { if (t) return; t = true; requestAnimationFrame(function () { t = false; pick(); }); }, { passive: true });
      pick();
    });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    root.classList.add('bn-ready');
    initReveal(); initPill(); initDrawer(); initWords(); initRails(); initTimeline();
    sweepReveal(); setTimeout(sweepReveal, 300); setTimeout(sweepReveal, 1200); setTimeout(sweepReveal, 3000);
    window.addEventListener('scroll', onScrollSweep, { passive: true });
    window.addEventListener('resize', onScrollSweep, { passive: true });
    window.addEventListener('load', sweepReveal);
    // Background-tab loads: rAF is paused and layout may have been 0×0 at boot.
    // When the page becomes visible, sweep directly (not via rAF) and re-run timeline pick.
    function onVisible() {
      if (document.visibilityState !== 'visible') return;
      sweepReveal(); setTimeout(sweepReveal, 250);
      window.dispatchEvent(new Event('scroll'));
    }
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('pageshow', onVisible);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { initReveal(); initPill(); initDrawer(); initWords(); initRails(); initTimeline(); sweepReveal(); });
})();
